/* eslint-disable*/
import "./Performance.css";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery-ui/ui/widgets/datepicker";
import "select2/dist/css/select2.min.css";
import "select2";
import DatePicker from "react-datepicker";
import { API_URL } from "../../config";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import LoadingSpinner from "../../components/LoadingSpinner";

const DailyShareview = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filtersReset, setFiltersReset] = useState(false);
  const token = localStorage.getItem("authToken");
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 100;

  const [dailyShareViewData, setDailyShareViewData] = useState([]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // ✅ Updated date formatter to use YYYY-MM-DD format for API
  const formatAPIDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (isNaN(date)) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // ✅ Keep existing date format for displaying in the table
  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (isNaN(date)) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const fetchDailyShareViewData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}researchCalls/dailyshareview`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          params: {
            limit,
            page,
            ...(startDate &&
              endDate && {
                sdate: formatAPIDate(startDate), // ✅ Correct format
                edate: formatAPIDate(endDate), // ✅ Correct format
              }),
          },
        }
      );
      setDailyShareViewData(response.data.data.shareview);
      setPageCount(response.data.data.totalPages);
      setTotal(response.data.data.total);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDailyShareViewData();
  }, [page]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pageCount) {
      setPage(newPage);
    }
  };

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  const handleChange = (dates) => {
    if (!dates) {
      setStartDate(null);
      setEndDate(null);
      return;
    }

    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const handleClear = () => {
    setStartDate(null);
    setEndDate(null);
    setFiltersReset(true);
  };

  useEffect(() => {
    if (filtersReset) {
      fetchDailyShareViewData();
    }
    setFiltersReset(false);
  }, [filtersReset]);

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchDailyShareViewData();
  };

  return (
    <>
      <div className="page-header-fixed page-sidebar-fixed fade in mt-5">
        <div id="content">{loading && <LoadingSpinner />}</div>
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form onSubmit={handleSubmit}>
            <div className="panel-heading border-0">
              <span className="panel-title">Search</span>
            </div>
            <div className="panel-body">
              <div className="d-flex align-items-center">
                <DatePicker
                  selected={startDate}
                  onChange={handleChange}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  isClearable
                  toggleCalendarOnIconClick
                  placeholderText="Select a date range"
                  className="form-control"
                  monthsShown={3}
                  openToDate={startDate} // Open at selected date if exists
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                  scrollableYearDropdown
                  yearDropdownItemNumber={15}
                  minDate={new Date(2018, 0, 1)}
                  maxDate={new Date(2030, 11, 31)}
                  dateFormat="dd-MM-yyyy"
                />

                <div className="d-flex gap-1">
                  <button type="submit" className="btn btn-primary mx-2">
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleClear}
                  >
                    Clear All
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="d-flex align-items-center justify-content-between">
            <div className="panel-heading border-0">
              <h4 className="panel-title">
                Manage Daily Sharing Research Calls
              </h4>
            </div>
            <div className="me-3">
              <span style={{ fontSize: "0.8rem" }} className="me-2">
                {start} to {end} of {total}
              </span>
              <button
                className="btn btn-default btn-sm"
                title="Previous"
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 1}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              &nbsp;
              <button
                className="btn btn-default btn-sm"
                title="Next"
                onClick={() => handlePageChange(page + 1)}
                disabled={page === pageCount}
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          </div>

          {dailyShareViewData.length > 0 && (
            <div className="table-responsive panel panel-default with-rounded-corner with-shadow p-10">
              <table className="table table-condensed table-bordered bg-white">
                <thead className="thead-light">
                  <tr>
                    <th className="text-center">Sr No.</th>
                    <th>Report Date</th>
                    <th>Share</th>
                  </tr>
                </thead>
                <tbody>
                  {dailyShareViewData.map((post, index) => {
                    return (
                      <tr key={post.id}>
                        <td className="text-center">
                          {(page - 1) * limit + index + 1}
                        </td>
                        <td>{formatDisplayDate(post.date)}</td>
                        <td>
                          <Link
                            to={post.file_path}
                            className="btn btn-danger"
                            target="_blank"
                          >
                            <FontAwesomeIcon icon={faDownload} />
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {dailyShareViewData.length === 0 && <div>No records found.</div>}
        </div>

        <Link href="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti ti-arrow-up"></i>
        </Link>
      </div>
    </>
  );
};

export default DailyShareview;
